<style scoped lang="scss">
  .wrap-products{
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
    .el-menu{
      border-right: 0;
      background: #F9F9F9;
    }
    .page2{
      display: none;
    }
    .page1{
      display: block;
    }
    .record{
      padding:15px;
      border: 1px solid #E4E6EA;
      margin-top: 20px;
      .title{
        padding:10px 0;
        font-weight: bold;
        border-bottom: 1px solid #E4E6EA;
      }
      li{
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-top: 15px;
        .te{
          word-break:break-word;
        }
        img{
          width:40px;
          height: 40px;
          margin-right: 10px;
        }
      }
    }
    .product-lists{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      .el-select{
        width: fit-content!important;
      }
      li{
        padding:30px;
        border: 1px solid #E4E6EA;
        width:calc(50% - 10px);
        margin-top: 20px;
      }
      .top{
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .title{
        font-size: 16px;
        font-weight: bold;
        margin:3px 0 11px;
      }
      .price{
        font-size: 24px;
        font-weight: bold;
        color: #014492;
        margin-top: 10px;
        small{
          font-size: 14px;
          font-weight: normal;
        }
      }
      .img-box{
        position: relative;
        margin-right: 20px;
        width:106px;
        height:106px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          display: block;
          font-size: 0;
          width:100%;
          height:100%;
        }
      }
      .rank{
        position: absolute;
        bottom:0;
        left:0;
        padding:2px 8px;
        color: #fff;
        font-size: 12px;
        background: rgba(0,0,0,.5);
      }
      label{
        display: block;
        margin-bottom: 5px;
      }
      .el-select{
        width:90px;
      }
      .el-input-number{
        width:90px;
      }
      .num{
        margin-left: 10px;
        margin-right: 25px;
      }
      .bot{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-top: 10px;
      }
      .el-badge{
        margin-left: 10px;
      }
      .el-badge__content{
        padding:0 5px;
      }
      .add-chart{
        width:40px;
        display: block;
        font-size: 0;
      }
    }
  }
  .products{
    .el-menu-item{
      span{
        width:100%;
        display: block;
      }
    }
    .el-menu-item.is-active{
      font-weight: bold;
      background: none;
    }
  }
  @media screen and (max-width: 640px){
    .container{
      width: 90% !important;
      font-size: 14px!important;
    }
    .mr42{
      float: left;
      display: block!important;
    }
    .wrap-products .product-lists .title{
      font-size: 14px!important;
    }
    .wrap-products .product-lists .price{
      font-size: 16px!important;
    }
    .mr41{
      display: none!important;
    }
    .container>>> .el-submenu__title{
      height: 40px!important;
      line-height: 40px!important;
    }
    .el-col-5{
      width: 100% !important;
    }
    .page2{
      display: block!important;
    }
    .page1{
      display: none!important;
    }
    .wrap-products .product-lists .img-box{
      width: 300px!important;
    }
    .wrap-products .product-lists .info{
      width: 90%!important;
    }
    .tr{
      display: none;
    }
    .el-col-19{
      width: 100% !important;
    }
    .wrap-products .product-lists{
      display: block!important;
    }
    .wrap-products .product-lists li{
      width:calc(100% - 10px) !important;
    }
    .wrap-products .product-lists .el-select{
      width: 120px!important;
      float: left;
      margin-bottom: 20px;
    }
    .wrap-products .product-lists .bot{
      display: block!important;
    }
    .wrap-products .product-lists .num{
      float: left;
      margin-left: 20px;
      margin-top: -23px;
      margin-bottom: 20px;
      margin-right: 0!important;
    }
    .btn{
      margin-right: 20px;
    }
    .wrap-products .record{
      margin-bottom: 20px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 414px){
    .wrap-products .product-lists .el-select{
      width: 100% !important;
      float: none!important;
    }
    .wrap-products .product-lists .num{
      width: 100% !important;
      float: none!important;
      margin-left: 0!important;
      margin-top: 0!important;
    }
    .wrap-products .product-lists .el-input-number{
      width: 100% !important;
    }
  }
</style>
<template>
  <div class="wrap wrap-products">
    <div class="banner">
      <el-carousel :interval="5000" arrow="never" :height="bannerHeight">
        <el-carousel-item v-for="item in bannerLists" :key="item.id">
          <img :src="item.img.visitedUrl" class="img-fluid" :class="{pointer: item.clickTriggerAction !== 'NONE'}" style="height:100%;" @click="toCarouselLink(item)">
<!--          <div class="info" @click="toCarouselLink(item)">-->
<!--            <div class="container">-->
<!--              <h1>分子产品中心</h1>-->
<!--              <h2 class="mt10">擎科分子产品中心擎科分子产品中心擎科分子<br>产品中心擎科分子产品中心</h2>-->
<!--            </div>-->
<!--          </div>-->
        </el-carousel-item>
      </el-carousel>
    </div>
    <section class="container products">
      <el-row :gutter="40">
        <el-col :span="5">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-vertical-demo">
            <el-menu-item index="全部商品" @click="getGoodsUrl('全部商品')">全部商品</el-menu-item>
            <component v-for="item in categories" :index="item.name" :key="item.id" :is="item.children.length > 0 ? 'el-submenu' : 'el-menu-item'" v-if="item.canShow">
              <template slot="title">
                <span @click="getGoodsUrl(item.name, item.id)">{{item.name}}</span>
              </template>
              <template v-if="item.children.length > 0">
                <el-menu-item class="menu-item" v-for="v in item.children" :key="v.id" :index="v.name" @click="getGoodsUrl(v.name, v.id)">
                  <span slot="title">{{v.name}}</span>
                </el-menu-item>
              </template>
            </component>
          </el-menu>
          <div class="record">
            <div class="title">浏览记录</div>
            <ul>
              <li v-for="item in records" :key="item.id" @click="$router.push(`/products/details/${item.id}`)">
                <img :src="item.mainImgUrl">
                <div class="info">
                  <div class="te">{{item.name}}</div>
                  <p class="text-primary fb">¥ {{item.price | amount}}</p>
                </div>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="text-primary fb">{{total}}件商品</div>
          <ul class="product-lists">
            <li v-for="(item, index) in goodsLists" :key="item.id">
              <div class="top" @click="$router.push(`/products/details/${item.id}`)">
                <div class="img-box"><img :src="item.mainImgUrl">
                  <span class="rank">{{item.skuDetails.code}}</span>
                </div>
                <div class="info">
                  <div class="title text-ellipsis">{{item.name}}</div>
                  <p class="text-gray9 text-ellipsis2" style="height:40px;line-height: 20px;" v-html="item.title"></p>
                  <p class="price">¥ {{item.skuDetails.price | amount}}</p>
                </div>
              </div>
              <div class="bot">
                <div class="specs">
                  <label>规格：</label>
                  <el-select v-model="item.curSku" placeholder="请选择规格" @change="changeSku($event, index)">
                    <el-option
                      v-for="(itx, index) in item.skus"
                      :key="index"
                      :label="itx.spec"
                      :value="itx.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="num">
                  <label>数量：</label>
                  <el-input-number v-model="item.skuNum" controls-position="right" :min="1" :max="100"></el-input-number>
                </div>
                <el-button class="btn mr42" size="mini" type="primary" @click="toBuy(item)">立即购买</el-button>
                <el-button class="btn mr41"  type="primary" @click="toBuy(item)">立即购买</el-button>
                <el-badge :value="item.num" class="item" :hidden="item.num===0 || item.specs === ''">
                  <img src="@/assets/images/icon_chart2.png" class="add-chart pointer" @click="toChart(item)">
                </el-badge>
              </div>
            </li>
          </ul>
          <div class="page tr page1" v-show="total > 0">
            <el-pagination
              layout="sizes, prev, pager, next"
              :total="total"
              @size-change="changeSizes"
              @current-change="changePage">
            </el-pagination>
          </div>
          <div class="page tc page2" v-show="total > 0">
            <el-pagination
              layout="sizes, prev, pager, next"
              :total="total"
              small
              @size-change="changeSizes"
              @current-change="changePage">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
import { productsCarousels, productCategories, productGoods, browsingHistories, createCarts, updateCarts, carts } from '@/services/api.index'
export default {
  inject: ['reload'],
  data () {
    return {
      specs: '',
      categories: [],
      bannerLists: [],
      goodsLists: [],
      records: [],
      total: 0,
      cartLists: [],
      bannerHeight: '',
      page: 0,
      size: 10,
      defaultActive: ''
    }
  },
  created() {
    this.getBanners()
    this.getCategories()
    this.getRecords()
  },
  beforeMount () {
    this.bannerHeight = document.body.clientWidth * 450 / 1440 + 'px'
  },
  methods: {
    // banner轮播
    getBanners () {
      productsCarousels().then(res => {
        this.bannerLists = res.data
      })
    },
    toCarouselLink (item) {
      this.baseMethods.carouselsAction(item)
    },
    // 获取分子分类菜单
    getCategories () {
      productCategories().then(res => {
        let categories = []
        let childrenLists = []
        res.data.map(item => {
          if (item.level === 1) {
            categories.push(item)
          } else {
            childrenLists.push(item)
          }
        })
        categories.map(item => {
          item.children = []
          childrenLists.map(itx => {
            if (itx.level === 2 && itx.parent.id === item.id) {
              item.children.push(itx)
            }
          })
        })
        this.categories = categories
        this.getCurrentProduct()
      })
    },
    // 商品查询
    getGoods (id) {
      const { page, size } = this
      productGoods(id, page, size).then(res => {
        res.data.map(item => {
          item.skuDetails = item.skus[0]
          item.curSku = item.skus[0].id
          item.num = 0
          item.skuNum = 0
        })
        this.goodsLists = res.data
        this.total = this.baseMethods.getTotal(res)
        if (this.baseMethods.getLocalObj('userInfo')) {
          this.getCartInfo()
        }
      })
    },
    getGoodsUrl (name, id) {
      id = id || ''
      this.$router.push(`/products?id=${id}&name=${name}`)
    },
    // 商品浏览记录
    getRecords () {
      browsingHistories().then(res => {
        this.records = res.data
      })
    },
    // 获取购物车信息
    getCartInfo () {
      carts().then(res => {
        this.cartLists = res.data
        this.goodsLists.map(itx => {
          itx.num = 0
        })
        res.data.map(item => {
          this.goodsLists.map(itx => {
            if (itx.id === item.sku.goods.id) {
              itx.num += item.quantity
            }
          })
        })
      })
    },
    changeSku (value, index) {
      const currentProduct = this.goodsLists[index].skus.filter(item => item.id === value)
      this.goodsLists[index].skuNum = 0
      this.goodsLists[index].skuDetails = currentProduct[0]
      this.goodsLists[index].curSku = value
    },
    // 立即购买
    toBuy (item) {
      if (item.skuNum === 0) {
        this.$message.error('请添加数量')
        return
      }
      this.baseMethods.setLocalObj('goodsInfo', item)
      this.$router.push('/products/chart_confirm')
    },
    async toChart (item) {
      let quantity = item.skuNum
      const currentPro = this.cartLists.filter(itx => itx.sku.id === item.curSku)
      if (currentPro.length > 0) {
        quantity += currentPro[0].quantity
      }
      createCarts(item.curSku, quantity).then(() => {
        this.reload()
        this.getCartInfo()
      })
    },
    getCurrentProduct () {
      const queryName = this.$route.query.name
      const currentPro = this.categories.filter(item => item.name === queryName && item.canShow)
      let id = this.$route.query.id
      if (currentPro.length === 0 && !id) {
        this.defaultActive = '全部商品'
      }
      if (!id && currentPro.length > 0) {
        id = currentPro[0].id
      }
      this.getGoods(id)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      const id = this.$route.query.id
      this.getGoods(id)
    },
    changeSizes (value) {
      this.size = value
      const id = this.$route.query.id
      this.getGoods(id)
    }
  },
  watch: {
    $route (to) {
      this.defaultActive = to.query.name
      this.page = 0
      this.getCurrentProduct()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/index.vue